import React, { useState, useEffect, useRef } from "react";
import "../common/index.scss";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

// CSS
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "./leftSidebar.scss";

// Store & Actions
import store from "../../store";
import {
  addToCart,
  addToCartUnsafe,
  addToWishlist,
  changeRouteName,
  getAllProducts,
} from "../../actions";

import ScrollToTop from "../pages/scroll_to_top";
import ProductDetailsMe from "./productDetailsI";
import EmptySearch from "../../svg_code/emptySearch";
import LoaderSpinner from "../../components/loadingspin";
import { ProductDetailSkeleton } from "../common/loaders/SkeletonLoaders";

const normalizeProductSlug = (rawId) => {
  if (!rawId) return "";
  const parts = rawId.split("-");
  const lastPart = parts[parts.length - 1];
  return /^\d+$/.test(lastPart) ? parts.slice(0, -1).join("-") : rawId;
};

function LeftSideBar({
  item,
  pathName,
  shortView,
  CutLoading,
  location,
  match,
}) {
  const topRef = useRef(null);
  const [loading, setLoading] = useState(true);

  const rawParam =
    match?.params?.id ||
    (location?.pathname ? location.pathname.split("/product/")[1] : "") ||
    "";

  const parts = rawParam ? rawParam.split("-") : [];
  const lastPart = parts.length > 0 ? parts[parts.length - 1] : "";
  const productIdFromUrl = /^\d+$/.test(lastPart) ? Number(lastPart) : null;
  const categoryId =
    location?.state?.category_ids ||
    item?.category?.[0]?.category_id ||
    null;
  const productId =
    location?.state?.product_id ||
    productIdFromUrl ||
    null;

  const lastFetchedParamRef = useRef(null);

  useEffect(() => {
    if (!rawParam) return;

    // If param changed or item is not yet present, fetch new product details
    const isNewParam = lastFetchedParamRef.current !== rawParam;
    if (isNewParam || !item) {
      lastFetchedParamRef.current = rawParam;
      setLoading(true);

      store.dispatch(changeRouteName([{ routeName: pathName }]));
      store.dispatch(
        getAllProducts(categoryId, productId, () => {
          setLoading(false);
        })
      );

      if (topRef.current) {
        topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else {
      setLoading(false);
    }
  }, [rawParam, location?.pathname, location?.search]);

  useEffect(() => {
    store.dispatch(changeRouteName([{ routeName: pathName }]));
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [pathName]);

  // ── Render ──
  return (
    <div>
      {/* Invisible anchor for smooth scroll to top */}
      <div
        ref={topRef}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "1px",
          width: "1px",
          pointerEvents: "none",
        }}
      />

      {loading ? (
        <div style={{ minHeight: "100vh", paddingTop: "30px", paddingBottom: "60px" }}>
          <ScrollToTop />
          <ProductDetailSkeleton />
        </div>
      ) : item ? (
        <>
          <ScrollToTop />
          <ProductDetailsMe
            key={item?.id || rawParam}
            pathName={pathName}
            shortView={shortView}
            item={item}
            CutLoading={CutLoading}
          />
        </>
      ) : (
        <div
          className="text-center"
          style={{
            minHeight: "70vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "2rem",
          }}
        >
          <ScrollToTop />
          <EmptySearch />
          <br />
          <br />
          <h4 className="fw-bold mb-3">Sorry, No Products Found!</h4>
          <p className="text-muted">
            The product you're looking for might have been removed or is
            temporarily unavailable.
          </p>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  let productasdId = ownProps?.url
    ? ownProps?.url
    : ownProps?.match?.params?.id;

  const rawId = productasdId || "";
  const parts = rawId ? rawId.split("-") : [];
  const lastPart = parts.length > 0 ? parts[parts.length - 1] : "";
  const numericId = /^\d+$/.test(lastPart) ? Number(lastPart) : null;
  const slug = /^\d+$/.test(lastPart) ? parts.slice(0, -1).join("-") : rawId;

  const productsData = state?.data?.products?.data || [];

  const foundItem =
    productsData.find((el) => {
      if (numericId && (el?.id === numericId || el?.api?.id === numericId)) return true;
      if (slug && (el?.api?.url_key === slug || el?.url_key === slug)) return true;
      if (rawId && (el?.api?.url_key === rawId || el?.url_key === rawId)) return true;
      return false;
    }) ||
    (numericId && productsData.length === 1 ? productsData[0] : null) ||
    productsData.find((el) => el?.api?.url_key === slug) ||
    null;

  return {
    pathName: slug,
    item: foundItem,
    symbol: state?.data?.symbol,
    review: state?.data?.reviewsdata?.data || [],
    shortView: ownProps?.url ? true : false,
  };
};

export default connect(mapStateToProps, {
  addToCart,
  addToCartUnsafe,
  addToWishlist,
})(withRouter(LeftSideBar));
